import React from "react"
import { useTheme } from "@material-ui/core"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import JobSummary from "../common/JobSummaryChart"

const ExtractSummaryView = () => {
	const [t] = useTranslation("global")
	const caseDetails = useSelector((state) => state.bifrostCaseDetails.caseDetails)
	const isPageLoading = useSelector((state) => state.bifrostCaseDetails.isLoading)

	const theme = useTheme()

	const getChartData = () => {
		const chartData = [["File type", "count", { role: "style" }, { role: "tooltip" }]]

		caseDetails.text_extract_summary?.forEach((summaryObj) => {
			const typeData = [
				summaryObj?.type,
				summaryObj?.virtual_bfiles_count,
				theme.palette.barGraph.B20,
				`${summaryObj?.type}(${summaryObj?.virtual_bfiles_count}, ${summaryObj?.virtual_bfiles_size})`,
			]
			chartData.push(typeData)
		})
		return chartData
	}
	return (
		<JobSummary
			data={getChartData()}
			loading={isPageLoading}
			title={t("bifrost.titles.overallCountExtracted")}
			legends={[{ text: t("bifrost.charts.fileTypes"), color: theme.palette.barGraph.B20 }]}
			axisTitle={{ x: t("bifrost.charts.fileTypes"), y: t("bifrost.charts.counts") }}
		/>
	)
}

export default ExtractSummaryView
